import { FadedImage } from "../../FadedImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-books-park-word-you-carry.jpg`;
const ALT = "Lara sitting cross-legged on a blanket in a sunlit park, reading The Word You Carry.";

export function TheWordYouCarry() {
  return (
    <section data-testid="books-word-you-carry" className="relative overflow-hidden bg-[#FAFAF8]">
      <div className="relative w-full overflow-hidden reveal pb-10 lg:pb-0">
        {/* Desktop image half-band, right side */}
        <div className="hidden lg:block absolute inset-y-0 right-0 w-[52%]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="books-word-you-carry-image"
            bg="#FAFAF8"
            objectPosition="50% 38%"
            featherLeft={60}
            featherTop={10}
            featherBottom={10}
            fadeOpacity={0.62}
            className="absolute inset-0"
          />
        </div>

        {/* Mobile image stacked on top */}
        <div className="lg:hidden relative w-full aspect-[4/5] mt-2">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="books-word-you-carry-image-mobile"
            bg="#FAFAF8"
            objectPosition="50% 30%"
            featherBottom={20}
            className="absolute inset-0"
          />
        </div>

        {/* Text on the clean left */}
        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 pt-8 lg:pt-0 flex items-center lg:min-h-[520px]">
          <div className="w-full lg:w-[44%]">
            <div className="max-w-[730px]">
              <h2
                data-testid="books-word-you-carry-header"
                className="font-display text-[34px] md:text-[44px] text-[#1C1917] leading-[1.15]"
              >
                The Word You Carry
              </h2>
              <p className="mt-[4px] mb-[8px] font-display text-xl md:text-2xl text-[#159E9A] leading-snug">
                Because the words you carry become the life you live.
              </p>
              <div className="space-y-4 text-lg md:text-xl leading-relaxed text-[#57534E]">
                <p>
                  Some books ask you to read from beginning to end. This one
                  simply asks you to begin where you are.
                </p>
                <p>
                  Open to any page. Choose one word. Carry it with you.
                  Sometimes a single word is enough to change the way you
                  walk through an ordinary day.
                </p>
              </div>
              <div className="mt-8">
                <a
                  href="https://a.co/d/0bbwrBCu"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="books-word-you-carry-buy-link"
                  className="inline-flex items-center justify-center gap-2 bg-[#FF5A4F] text-white rounded-[8px] px-6 py-3 text-sm font-medium hover:bg-[#e8463c] transition-colors"
                >
                  Buy on Amazon
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
